import { HttpClient } from "@angular/common/http";
import { LoginService } from "./../../../../login/login.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { LocalStorageService } from "src/app/utils/localstorage.service";
import { environment } from "../../../../../environments/environment";
import { Observable, Subject } from "rxjs";

@Injectable()
export class MyAccountService {
  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private router: Router,
    private loginService: LoginService
  ) {}

  change_user_data(userdata): Promise<any> {
    const data = {
      currentPassword: userdata.currentPassword,
      newPassword: userdata.newPassword,
      phoneNumber: userdata.phone_number,
      isUpdatingPassword: userdata.isUpdatingPassword,
    };

    return this.http
      .patch(`${environment.apiUrl}/user/password`, data)
      .toPromise();
  }

  get_2fa_status(): Promise<any> {
    return this.http.get(`${environment.apiUrl}/user/verify-sms`).toPromise();
  }

  remove_2fa(): Promise<any> {
    return this.http
      .delete(`${environment.apiUrl}/user/verify-sms`)
      .toPromise();
  }

  generate_sms_token(phoneNumber): Promise<any> {
    const data = {
      phoneNumber,
    };

    return this.http
      .post(`${environment.apiUrl}/user/send-token-sms`, data)
      .toPromise();
  }

  verify_sms_token(code): Promise<any> {
    const data = {
      code,
    };

    return this.http
      .post(`${environment.apiUrl}/user/verify-sms`, data)
      .toPromise();
  }

  verify_sms_token_phone(userUuid, code): Promise<any> {
    const data = {
      code,
      user_uuid: userUuid,
    };

    return this.http
      .post(`${environment.apiUrl}/user/verify-sms-phone`, data)
      .toPromise();
  }

  add_pin(newPin, pinTimeout): Promise<any> {
    const data = {
      newPin: newPin,
      pinTimeout: pinTimeout,
    };

    return this.http.post(`${environment.apiUrl}/user/pin`, data).toPromise();
  }

  change_pin(currentPin, newPin, pinTimeout): Promise<any> {
    const data = {
      currentPin: currentPin,
      newPin: newPin,
      pinTimeout: pinTimeout,
    };

    return this.http.patch(`${environment.apiUrl}/user/pin`, data).toPromise();
  }

  check_pin(pin): Promise<any> {
    const data = {
      pin: pin,
    };

    return this.http
      .post(`${environment.apiUrl}/user/pin.check`, data)
      .toPromise();
  }

  set_push_keys(keys) {
    return this.http.post(`${environment.apiUrl}/user/keys`, keys).toPromise();
  }

  update_has_web_push(has_push) {
    const data = {
      has_web_push_enabled: has_push,
    };
    return this.http
      .put(`${environment.apiUrl}/user/webpush.enabled`, data)
      .toPromise();
  }

  get_has_web_push() {
    return this.http
      .get(`${environment.apiUrl}/user/webpush.enabled`)
      .toPromise();
  }

  savePicture(picture): Observable<any> {
    return this.http.patch(`${environment.apiUrl}/user/picture`, { picture });
  }

  getMyDevices() {
    return this.http.get(`${environment.apiUrl}/user/devices`).toPromise();
  }

  removeDevice(uuid) {
    return this.http
      .delete(`${environment.apiUrl}/user/devices/${uuid}`)
      .toPromise();
  }

  updateUserName(payload: {
    first_name: string;
    last_name: string;
  }): Observable<any> {
    const data = {
      first_name: payload.first_name,
      last_name: payload.last_name,
    };

    return this.http.patch(`${environment.apiUrl}/user/update`, data);
  }

  updateSoundsEnabled(enabled: boolean): Observable<{ sounds_enabled: boolean }> {
    return this.http.patch<{ sounds_enabled: boolean }>(
      `${environment.apiUrl}/user/sounds`,
      { sounds_enabled: enabled },
    );
  }
}
